import {Link} from '@primer/react'
import {Fragment} from 'react'

import {containsSafeContent, isValidAndSafeUrl, prefixUrl, sanitizeInput} from '../../../utils/url'

// A non-greedy regex without limits may run slow on strings with many repetitions of symbols.
// (See more details in https://github.com/github/github-ui/security/code-scanning/556)
// This regex captures up to 3 opening punctuation characters, up to 1000 characters of main text,
// and up to 10 closing punctuation characters.
const PUNCTUATION_REGEX = /^([(['"]{0,3})(.{1,1000}?)([.,:;!?\])"']{0,10})$/

function cleanPunctuation(text: string): {cleanText: string; prefix: string; suffix: string} {
  const match = text.match(PUNCTUATION_REGEX)
  if (!match) {
    return {cleanText: text, prefix: '', suffix: ''}
  }

  const [_fullMatch, prefix = '', cleanText = '', suffix = ''] = match
  return {cleanText, prefix, suffix}
}

export function renderTextWithLinks(text: string): React.ReactElement | null {
  if (!text) {
    return null
  }

  const fragments = text.split(/(\s+)/)

  return (
    <>
      {fragments.map((fragment, index) => {
        const fragmentKey = `${fragment}-${index}`

        if (!fragment.trim()) {
          return <Fragment key={fragmentKey}>{fragment}</Fragment>
        }

        const {cleanText, prefix, suffix} = cleanPunctuation(fragment)

        if (!cleanText) {
          return <Fragment key={fragmentKey}>{fragment}</Fragment>
        }

        const sanitizedFragment = sanitizeInput(cleanText)
        const prefixedUrl = prefixUrl(sanitizedFragment)

        if (isValidAndSafeUrl(prefixedUrl) && containsSafeContent(prefixedUrl)) {
          return (
            <Fragment key={fragmentKey}>
              {prefix}
              <Link href={prefixedUrl} rel="noopener noreferrer">
                {sanitizedFragment}
              </Link>
              {suffix}
            </Fragment>
          )
        }

        return <Fragment key={fragmentKey}>{fragment}</Fragment>
      })}
    </>
  )
}
